export function safeImageUrl(url: string): string {
  if (!url) return url;
  try {
    return encodeURI(decodeURI(url));
  } catch {
    return url;
  }
}

interface ImageVersions {
  imageUrl: string;
  thumbnailUrl?: string | null;
  mediumUrl?: string | null;
}

const THUMBNAIL_WIDTH = 600;
const MEDIUM_WIDTH = 1000;
const MAIN_WIDTH = 1600;

export function productImageSrcSet(image: ImageVersions | undefined): string | undefined {
  if (!image?.thumbnailUrl) return undefined;
  const candidates = [`${safeImageUrl(image.thumbnailUrl)} ${THUMBNAIL_WIDTH}w`];
  if (image.mediumUrl && image.mediumUrl !== image.imageUrl) {
    candidates.push(`${safeImageUrl(image.mediumUrl)} ${MEDIUM_WIDTH}w`);
  }
  candidates.push(`${safeImageUrl(image.imageUrl)} ${MAIN_WIDTH}w`);
  return candidates.join(', ');
}

export function thumbnailUrlOf(image: ImageVersions | undefined): string {
  return image?.thumbnailUrl || image?.imageUrl || '';
}
